import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=409bff6e&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=ts"
export * from "./indexCopy.vue?vue&type=script&lang=ts"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=409bff6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bff6e",
  null
  
)

export default component.exports